import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { PatientActions } from 'src/redux/actions/constant';

import patientService from 'src/services/apiServices/patientService';

const { FAILURE_EDIT_PATIENT, SUCCESS_EDIT_PATIENT, REQUEST_EDIT_PATIENT, LOADING_EDIT_PATIENT, GET_ALL_PATIENT_PRIOR_CHARGES_REQUEST } =
  PatientActions;

function* editPatients(action: any): SagaReturnType<any> {
  try {
    yield put({ type: LOADING_EDIT_PATIENT });
    const response = yield call(patientService.editPatient, action.payload);      
    if (response?.status === 200) {
      yield put({ type: SUCCESS_EDIT_PATIENT, payload: response.data });
      yield put({ type: GET_ALL_PATIENT_PRIOR_CHARGES_REQUEST, patientUuid: action.payload.uuid });

    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: FAILURE_EDIT_PATIENT, payload: error });
  }
}

function* editPatientsSaga() {
  yield takeEvery(REQUEST_EDIT_PATIENT, editPatients);
}

export default editPatientsSaga;
